var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    viewBox: "0 0 39 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 6.8,
    fill: "#106EB7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 13.5996,
    width: 39,
    height: 6.8,
    fill: "#106EB7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 27.1992,
    width: 39,
    height: 6.8,
    fill: "#106EB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurger);
export default __webpack_public_path__ + "static/media/menu_burger.b7bdc1196d56eba5edfb36ef960e66a0.svg";
export { ForwardRef as ReactComponent };